// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__qQj9z","footer":"Form_footer__2611J"};